import { defineBlock, smartProps, useEditor, BlockWrapper } from '@smartfire/js-block-engine';
import { EditableImg, EditableText } from '@smartfire/components';
import style from './style.module.scss';

const Block = ({ description }) => {
    const { isEditing } = useEditor();

    return (
        <BlockWrapper.Article className={style.block}>
            <EditableImg className={style.image} smartProp="image" />
            {(isEditing || description) && (
                <EditableText tagName="p" placeholder="Titre..." smartProp="title" className={style.title} />
            )}
            {(isEditing || description) && (
                <EditableText
                    tagName="p"
                    placeholder="Description..."
                    smartProp="description"
                    className={style.description}
                />
            )}
        </BlockWrapper.Article>
    );
};

export default defineBlock({
    Block: Block,
    smartProps: {
        image: smartProps.image,
        title: smartProps.string.withDefault(''),
        description: smartProps.string.withDefault(''),
    },
    setup: {
        title: 'Réassurance - Elément',
        parent: ['smartfire/reassurance'],
    },
});
